import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { MentionSearchCriteriaModel } from '../../../Monitor/Shared/models/mention-search-criteria.model';


@Injectable()
export class FilterResolver implements Resolve<MentionSearchCriteriaModel> {

    resolve(route: ActivatedRouteSnapshot): MentionSearchCriteriaModel {
        if (!route.queryParams['filters']) {
            return null;
        }

        return MentionSearchCriteriaModel.fromFilterQueryString(route.queryParams['filters'])?.search;
    }
}
